import moment from 'moment'
import word from 'assets/pictures/logos/word.svg'
import pdf from 'assets/pictures/logos/pdf.svg'
import excel from 'assets/pictures/logos/excel.svg'
import powerpoint from 'assets/pictures/logos/powerpoint.svg'
import text from 'assets/pictures/logos/txt.svg'
import defaultLogo from 'assets/pictures/logos/text.svg'
import { DOCUMENT, DOCUMENT_TYPES, EXCEL_EXTENSIONS, PDF_EXTENSIONS, PICTURE, PICTURE_TYPES, POWERPOINT_EXTENSIONS, TEXT_EXTENSIONS, WORD_EXTENSIONS } from 'components/file/constant/FileConstants'
import { SANDRE } from 'referencial/constants/ReferencialConstants'
import i18n from 'simple-react-i18n'
import { isNil } from 'lodash'
import { getI18nOrLabel } from './StringUtil'

const formatedFileName = (fileName) => {
    return fileName ? fileName.normalize('NFD').toUpperCase().replace(/[\u0300-\u036f]/g, '').replace(/[\u002f]/g, '_').split('_').join('-').replaceAll(' ', '-') : i18n.unknown
}

const STATION_TYPE_NAME = {
    piezometry: 'PIEZOMETRY',
    hydrometry: 'HYDROMETRY',
    quality: 'QUALITY',
    pluviometry: 'PLUVIOMETRY',
    productionUnit: 'PRODUCTION',
    distributionUnit: 'DISTRIBUTION',
    installation: 'INSTALLATION',
    resource: 'RESOURCE',
    catchment: 'CATCHMENT',
}

const getFormatedFileName = (stationCode, active = 0, fileName, extension = 'jpg', fileType = 'INCONNU', date = moment(), stationType, shared = false, point) => {
    const dateFormatted = (() => {
        if (isNaN(date)) {
            return '0-0'
        }
        if (!new RegExp('^[0-9]+-[0-9]+$').test(date)) {
            return moment(date).format('YYYYMMDD-HHmmss')
        }
        return date
    })()
    const stationTypeShared = shared ? '' : `_${STATION_TYPE_NAME[stationType]}`
    return `${stationCode}_${fileType}_${active.toString()}_${dateFormatted}${stationTypeShared}_${formatedFileName(fileName)}${isNil(point) ? '' : `.prel_${point.identifiant}_${point.startDate}`}.${extension}`
}

const getFileExtension = (fileName = '') => {
    return fileName.slice((Math.max(0, fileName.lastIndexOf('.')) || Infinity) + 1)
}

const getFileName = (fileName) => {
    return fileName.substr(0, fileName.lastIndexOf('.'))
}

const getFileNatureLabel = (file, sandreCodes) => {
    const [ , type] = file.name.substr(file.stationCode.length, file.name.lastIndexOf('.')).split('_')
    const findByMnemo = sandreCodes.find(s => s.mnemonique === type)
    const fileNature = findByMnemo ? findByMnemo.name : (sandreCodes.some(s => formatedFileName(s.name) === formatedFileName(type)) ? type : 'INCONNU')
    return fileNature
}

const getDocumentTypeIcon = (fileExtension) => {
    if (WORD_EXTENSIONS.includes(fileExtension)) {
        return word
    } else if (PDF_EXTENSIONS.includes(fileExtension)) {
        return pdf
    } else if (EXCEL_EXTENSIONS.includes(fileExtension)) {
        return excel
    } else if (POWERPOINT_EXTENSIONS.includes(fileExtension)) {
        return powerpoint
    } else if (TEXT_EXTENSIONS.includes(fileExtension)) {
        return text
    } return defaultLogo
}

const getTypeSandreCode = (type) => {
    if (type === PICTURE) {
        return SANDRE.TYPE_PHOTO
    } else if (type === DOCUMENT) {
        return SANDRE.TYPE_DOCUMENT
    } return SANDRE.TYPE_PHOTO
}

const getFileType = (content) => {
    if (!content) {
        return {}
    }
    if (content.includes(PICTURE_TYPES.IMAGE)) {
        return { title: i18n.pictureType, sandreCode: SANDRE.TYPE_PHOTO }
    } else if (content.includes(DOCUMENT_TYPES.APPLICATION) || content.includes(DOCUMENT_TYPES.TEXT)) {
        return { title: i18n.documentType, sandreCode: SANDRE.TYPE_DOCUMENT }
    } return {}
}

const convertToCSV = (headers, data) => {
    const listHeaders = headers.map(header => header?.key ?? header)
    const csvHeaders = listHeaders.map(key => getI18nOrLabel(key).replace(';', '_')).join(';')
    const csvRows = data.map(row => {
        return listHeaders.map(header => {
            const value = row[header] ?? ''
            return `${value}`.replace(/;/g, '_')
        }).join(';')
    })
    return [csvHeaders, ...csvRows].join('\n')
}

const downloadCSV = (headers, rows, name = i18n.file) => {
    const csvContent = convertToCSV(headers, rows)
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')

    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob)
        link.setAttribute('href', url)
        link.setAttribute('download', `${name}.csv`)
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
    }
}

export {
    getFormatedFileName,
    getFileExtension,
    getFileName,
    formatedFileName,
    getFileNatureLabel,
    getDocumentTypeIcon,
    getTypeSandreCode,
    getFileType,
    convertToCSV,
    downloadCSV,
}
